import { render, staticRenderFns } from "./HandleItemBrand.vue?vue&type=template&id=7504f5f2"
import script from "./HandleItemBrand.vue?vue&type=script&lang=js"
export * from "./HandleItemBrand.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports